<script>
    export let desc;
    export let selected;
    export let options;

    import _ from 'lodash';

    const selectionClick = (option) => {
        selected = option;
    };
</script>

<div class="horizontal-text-selection">
    <div class="horizontal-text-selection__desc">{desc}:</div>
    {#each options as option}
        {#if option !== _.get(options, 0)}
            <div class="horizontal-text-selection__seperator">|</div>
        {/if}
        <div 
            class={`horizontal-text-selection__option${option.key === selected ? ' selected' : ' unselected'}`}
            on:click={() => selectionClick(option.key)}
        >
            {option.title}
        </div>
    {/each}
</div>

<style>
    .horizontal-text-selection {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        font-size: 11px;
    }
    .horizontal-text-selection__desc {
        padding-right: 8px;
    }
    .horizontal-text-selection__option, .horizontal-text-selection__seperator {
        color: #1AAAD0;
    }
    .horizontal-text-selection__option {
        cursor: pointer;
    }
    .horizontal-text-selection__seperator {
        cursor: default;
    }
    .horizontal-text-selection__option.selected {
        font-weight: 700;
    }
    .horizontal-text-selection__option.unselected {
        color: #5FCEEA;
        letter-spacing: 0.3px;
    }
    .horizontal-text-selection__seperator {
        padding: 0 8px;
    }
</style>